import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium tracking-wide uppercase mb-3">
            Product Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            Explore All Spreadsheet Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Browse our comprehensive collection of Superbuy product spreadsheets, organized by category for easy navigation.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-3 md:p-4 rounded-xl bg-white border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className="w-full aspect-square rounded-lg overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center gap-2">
                <span className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200 shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-700 leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}